import { IMapLayerProvider } from 'app/config/IMapLayerProvider';

export abstract class AbstractMapLayerProviderList<T extends IMapLayerProvider> {
    protected _providers: T[];

    protected constructor(providers: T[] = []) {
        this._providers = providers;
    }

    /**
     * Returns a shallow copy of the terrain providers
     * @returns {ImsTerrainProvider[]}
     */
    get mapLayerProviders(): T[] {
        return this._providers.slice();
    }

    /**
     * Add a provider to the list
     * @param {ImsTerrainProvider} provider
     */
    addMapLayerProvider(provider: T) {
        this._providers.push(provider);
    }

    /**
     * Remove a provider from the list
     * @param {ImsTerrainProvider} provider
     */
    removeMapLayerProvider(provider: T) {
        this._providers = this._providers.filter((p) => p.uuid !== provider.uuid);
    }

    findByUuid(uuid: string) {
        return this._providers.find((p) => p.uuid === uuid);
    }

    toJS(): any[] {
        return this._providers.map((p) => p.toJS());
    }

    // any return value gets around the typing issue
    abstract clone(): this;
}
